<template>
  <div v-if="show" class="text-center bowl">
    <font-awesome-layers>
      <font-awesome-icon  icon="circle" class="glow"
                          transform="grow-8"   />
      <font-awesome-icon  :icon="['fas', 'trophy']"
                          style="color: white;"
                          transform="shrink-2 left-1"  />
    </font-awesome-layers>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
}
</script>

<style lang="scss" scoped>
  .glow {
    text-shadow: 1px 1px 2px black, 0 0 1em blue, 0 0 0.2em blue;
  }

  .bowl {
    height: 4rem;
    font-size: 1.75em;
    padding-top: 1.0rem;
    color: red;
  }
</style>
